<template>
  <div>
    <p>Total Number of Shares held in:</p>
    <div class="input-box">
      <input placeholder=" " />
      <div class="input-label">CDP Register</div>
    </div>
    <div class="input-box">
      <input placeholder=" " />
      <div class="input-label">Register of Stockholder</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormPFHT",
  props: {
    field: {
      type: Object,
    },
  },
};
</script>

<style scoped>
.input-box {
  border: 1px solid #d7d7d7;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  overflow: hidden;
  background: #fff;
  padding-left: 0.3rem;
  position: relative;
  overflow: visible;
  margin-bottom: 1rem;
}

.input-box > input {
  flex-grow: 1;
  font-size: 14px;
  background: #fff;
  border: none;
  outline: none;
  padding: 0.5rem;
  padding-left: 0;
  margin-top: 0.2rem;
  height: 1.5rem;
}

.input-label {
  position: absolute;
  transition: 0.2s;
  pointer-events: none;
  top: 0.65rem;
  font-size: 16px;
  white-space: nowrap;
  background: #fff;
}

.input-box > input:focus ~ .input-label,
.input-box > input:not(:placeholder-shown) ~ .input-label {
  top: -0.5rem;
  color: #0073c3;
  font-size: 13px;
  padding: 0 2px;
}

.input-box:focus-within {
  border: 2px solid #0073c3;
}

.required {
  color: #f00;
}
</style>